import { component } from 'picoapp'
import animateScrollTo from 'animated-scroll-to'

class FaqScroll {

  constructor(node, ctx) {
    // bindings
    this.onResize = this.onResize.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.onClickNavItem = this.onClickNavItem.bind(this)

    // selectors
    this._node = node
    this._faq_sections = this._node.querySelectorAll('.faq-section')
    this._faq_nav_items = this._node.querySelectorAll('.faq-nav-item')

    // event listeners
    window.addEventListener('resize', this.onResize)
    window.addEventListener('scroll', this.onScroll)
    window.dispatchEvent(new Event('resize'))

    this._faq_nav_items.forEach((el) => el.addEventListener('click', this.onClickNavItem, false))

    this.onResize()

    // unmount
    return this.unmount.bind(this)
  }

  //
  // Resize.
  //
  onResize() {
    this.onScroll()
  }

  //
  // Scroll.
  //
  onScroll() {
    let event_horizon = window.pageYOffset

    this._faq_sections.forEach((section, si) => {
      let top = section.getBoundingClientRect().top - 128,
          sid = section.getAttribute('data-id')

      if (top < 0) {
        this._faq_nav_items.forEach((item, ni) => {
          let nid = item.getAttribute('data-id')
          item.classList.remove('current')

          if (nid === sid) {
            item.classList.add('current')
          }
        })
      } else if (top >= 0 && si === 0) {
        this._faq_nav_items.forEach((item, ni) => {
          item.classList.remove('current')
        })
      }
    })
  }

  onClickNavItem(e) {
    let id = e.currentTarget.getAttribute('data-id'),
        section = this._node.querySelector(`.faq-section[data-id="${id}"]`),
        section_top = window.pageYOffset + section.getBoundingClientRect().top - 80

    animateScrollTo(section_top, {speed: 1500})
  }

  //
  // Unmount.
  //
  unmount() {
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('scroll', this.onScroll)
    this._faq_nav_items.forEach((el) => el.removeEventListener('click', this.onClickNavItem, false))
  }
}

export default component((node, ctx) => new FaqScroll(node, ctx))
